import { SITE } from "./site";

/**
 * Datos de contacto que se muestran en las páginas públicas del sitio.
 * Editables desde Preferencias → Contacto público (superadmin) y almacenados
 * en `crm_configuracion`. Las constantes de `SITE` actúan como respaldo.
 */
export interface ContactInfo {
  /** Correo de contacto mostrado y usado en enlaces mailto: */
  email: string;
  /** Teléfono mostrado (formato libre); los enlaces tel: se normalizan al render */
  phone: string;
  /** Número de WhatsApp en dígitos (sin +) para los enlaces wa.me */
  whatsapp: string;
}

/** Valores por defecto: replican las constantes actuales de la marca. */
export const DEFAULT_CONTACT: ContactInfo = {
  email: SITE.email,
  phone: SITE.phone,
  whatsapp: SITE.whatsapp,
};

/** Deja solo dígitos (elimina +, espacios, guiones, paréntesis). */
export function normalizeWhatsapp(value: string): string {
  return (value ?? "").replace(/\D/g, "");
}

/** Construye un href tel: a partir del teléfono mostrado, conservando el + inicial. */
export function telHref(phone: string): string {
  const trimmed = (phone ?? "").trim();
  const hasPlus = trimmed.startsWith("+");
  const digits = trimmed.replace(/\D/g, "");
  return `tel:${hasPlus ? "+" : ""}${digits}`;
}

/** Construye el enlace de WhatsApp wa.me con un mensaje opcional. */
export function whatsappHrefFor(whatsapp: string, msg: string = SITE.whatsappMsg): string {
  const digits = normalizeWhatsapp(whatsapp);
  return `https://wa.me/${digits}?text=${encodeURIComponent(msg)}`;
}
